import { useState, useEffect } from "react";
import { useResizeObserver } from "../../hooks/useResizeObserver.js";
import { getEvents } from "../../services/getListSponsored";
import { getLegalTextBySponsor } from '../../functions/functions.js';
import Loading from "../loading/loading";
import Legal from "../legal/legal";
import HeaderCardListSponsored from "./cardListSponsored/headerCardListSponsored/headerCardListSponsored";
import BodyCardListSponsored from './cardListSponsored/bodyCardListSponsored/bodyCardListSponsored';
import FooterCardListSponsored from './cardListSponsored/footerCardListSponsored/footerCardListSponsored';
import NoEvents from "../noEvents/noEvents";
import './listSponsored.sass';

/**
 * Renderiza una lista de eventos patrocinados semanales con momios y texto legal según el patrocinador.
 */
export default function ListSponsored({ flagMomios, patrocinador, title = "Calendario", version }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [heightLoading, setHeightLoading] = useState(0);

  const containerRef = useResizeObserver(setHeightLoading);
  const legalText = getLegalTextBySponsor(patrocinador); // Renderiza el texto legal si corresponde

  const activeMomios = flagMomios === true || flagMomios === "true";
  const endpoint = "events-weekly"// "principales/principales_semanal";

  // Fetch para obtener los eventos
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getEvents({ endpoint, version });
        setData(response?.data || []);
      } catch (error) {
        console.error("Error al obtener los datos:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  
  // Condición para mostrar header del card
  const shouldShowHeader = (itemClass) =>
    activeMomios && !["clarosports-finished-game", "clarosports-error-game"].includes(itemClass);

  return (
    <div className="container__list-sponsored" id="container__list-sponsored" ref={containerRef}>
      {
        loading
          ? <Loading type={heightLoading} />
          :
          <div className="list-sponsored__component">
            <div className="list-sponsored__component-header">{title}</div>

            <div className="list-sponsored__component-list">
              {data.length > 0 && data.map((item) => {
                return (
                  <div className="list-sponsored-card" key={item.id_juego}>
                    {shouldShowHeader(item.class) && <HeaderCardListSponsored item={item} patrocinador={patrocinador} />}

                    <BodyCardListSponsored item={item} flagMomios={activeMomios} patrocinador={patrocinador} clase={item.class} />

                    <FooterCardListSponsored
                      liga={item.liga}
                      opta_event_url={item.opta_event_url}
                      flagMomios={flagMomios}
                      patrocinador={patrocinador}
                      clase={item.class}
                      activeMomios={activeMomios}
                      statusEvent={item.period_title}
                      item={item}
                    />
                  </div>
                );
              })}

              {data.length === 0 && <NoEvents />}
            </div>

            {/* mostrar leyenda de copy legal */}
            {activeMomios && !loading && legalText.trim().length > 0 && (
              <Legal patrocinador={patrocinador} />
            )}
          </div>
      }
    </div>
  );
}